import {HanjaService} from "./hanja.service";

export const HanjaInjectables: Array<any> = [
  {
    provide: HanjaService,
    useClass: HanjaService,
  },
];
